import { FC } from "react";

import { FormProps } from "./types";

export const ObjectInput: FC<Readonly<FormProps>> = () => {
  return <></>;
};
